// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoStyles } from "@eisinc/Overrides/Widgets/Basic/Logo";
import { xScreen } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        gap: 12px;
        ${({ isCheckoutPage }: any) =>
            !isCheckoutPage &&
            css`
                ${xScreen("lte", "md")} {
                    max-width: 125px;
                    padding-top: 3px;
                }
            `}
    `,
};

logoStyles.menuClickable = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

logoStyles.homePageLink = {
    typographyProps: {
        css: css`
            display: flex;
            > span {
                display: inline-flex;
            }
        `,
    },
};
